module.exports = __webpack_public_path__ + "assets/imgs/logos/twitter.c8547b2521b63adf8728b3035b4772c0.png";